import {NamedUrl} from "@/models/Filters";

const COLORS: Array<string> = ['#151E41', '#6F2F67', '#CA4060', '#9F3469','#402859', '#EA594E',
    '#FD7C34','#FFA600','#F5B89A','#FFE8D3','#FFBEC3','#FF878D','#DFE0DF','#FF7E57', '#BCA79D','#D99E81',
    '#976B62','#D27B00','#7D3628','#FFD481','#A2A19D']

export const CHART_COLORS: Array<string> = COLORS

export const AVERAGE_COLOR = '#eeeeee'

export const ENVIRONMENT = {
    isLocal: window.location.host.indexOf('localhost') !== -1,
    isProduction: window.location.href.indexOf('www.outbrain.com') !== -1,
    isStaging: window.location.href.indexOf('stg-ny-brainpower') !== -1 || window.location.href.indexOf('stg-chi-brainpower') !== -1,
    isSimulator: window.location.href.indexOf('simulator-ny-brainpower') !== -1 || window.location.href.indexOf('simulator-chi-brainpower') !== -1,
    isTest: window.location.href.indexOf('www2') !== -1
}

export const FEATURES = {
    // isPeriodSelection: !ENVIRONMENT.isProduction,
    isPeriodSelection: true
}

export const FILTERS: Array<NamedUrl> = [
    {url: "datapoint/listAllVerticals", name: "categories"},
    {url: "datapoint/listAllRegions", name: "regions"},
    {url: "period/listTimePeriods", name: "periods",params:{state:ENVIRONMENT.isProduction?"QC_DONE":"QC_DONE,QC_IN_PROGRESS",limit:5}}
];

export const maxInfographicsPerRow = 2


export const LABELS = {
    previousPeriod: '(previous period)'
}
